import { IconButton, type SxProps } from '@mui/material'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import type { Theme } from '@mui/material/styles'

interface ToggleExpandButtonProps {
  sx: SxProps<Theme> | undefined
  open: boolean
  onClick?: () => void
}

export function ToggleExpandButton({ sx, open, onClick }: ToggleExpandButtonProps) {
  return (
    <IconButton size="small" className="sidebarMenuArrow" sx={sx} onClick={onClick}>
      {open ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
    </IconButton>
  )
}
